"use client";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import ICMWrapper from "@/app/components/icm-wrapper";
import ReferAndEarn from "@/app/unlisted-shares/components/refer-&-earn";
import Testimonial from "@/app/components/testimonial";
import Faq from "@/app/components/faq";
import ScrollableButtonRefer from "@/app/refer/components/refer-scrollable-button";
// import HowToComponent from "@/app/components/shared/how-to-component";
// import { HOW_TO_REFER_STEPS, HOW_TO_REFERRAL_STEPS } from "../constants/refer-data";
import { Suspense, useEffect, useState } from "react";
import { useAuth } from "@/context/authcontext";
// import { setAnalyticsEvent } from "../utils/SetAnalyticsEvent";
// import { initBranch, trackEvent } from "../utils/branchio";
import { getCleanDomain} from "../utils/helper";
import FCMInit from "../components/fcm-init";
import { AMZ_VOUCHER, ANNOUNCEMENT_TRIGGER_SCREENS } from "../utils/constants";
import { AnnouncementDialog } from "../components/popup/announcement";
import { FCM } from "../interface/homepage";
import HowToInvest from "../unlisted-shares/components/how-to-invest";
import HowTo1 from "@/app/assets/images/how-to-refer-1.png";
import HowTo2 from "@/app/assets/images/how-to-refer-2.png";
import HowTo3 from "@/app/assets/images/how-to-refer-3.png";
// import { useCleverTapEvents } from "../hooks/use-clevertap";

export default function Home() {
    const [active, setactive] = useState("refer");
    const [message, setmessage] = useState<FCM>();
    const [renderAnnouncement, setrenderAnnouncement] = useState<boolean>(false);
    const { isAuthenticated, isLoading } = useAuth();
    console.log("active ", active);
    // const { cleverTapTrackEvent } = useCleverTapEvents();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (message) {
            setrenderAnnouncement(true);
        }
    }, [message]);

    // const HandleRefer = () => {
    //     cleverTapTrackEvent("Refer_Homepage_Refer_Friend", {});
    //     // initBranch()
    //     //     .then(() => {
    //     //         trackEvent("Refer_Homepage_Refer_Friend", "", "");
    //     //     })
    //     //     .catch((error) => console.error("Error initializing Branch:", error));
    //     setAnalyticsEvent(`${process.env.ICM_URL}/refer`, "Refer_Homepage_Refer_Friend");

    //     setRedirectTo("/refer");
    //     if (isAuthenticated) {
    //         window.location.href = "/refer";
    //     } else {
    //         window.location.href = "/login";
    //     }
    // };

    return (
        <Suspense>
            <div>
                <FCMInit setMessage={setmessage} />
                {message?.triggerScreen === ANNOUNCEMENT_TRIGGER_SCREENS.ReferralScreen && (
                    <>
                        <AnnouncementDialog
                            renderAnnouncement={renderAnnouncement}
                            setrenderAnnouncement={setrenderAnnouncement}
                            data={message}
                        />
                    </>
                )}
                <ICMWrapper>
                    <Breadcrumb
                        paths={
                            [
                                { label: "Home", route: isAuthenticated ? "/platform" : "/" },
                                { label: "Refer" },
                            ] as BreadcrumbPath[]
                        }
                    />
                </ICMWrapper>
                <ReferAndEarn
                    active="Refer"
                    setactive={setactive}
                    isAuthenticated={isAuthenticated}
                    authLoading={isLoading}
                    footerText={
                        "Your friend will receive 0.25% earnings on their first transaction only"
                    }
                    voucherAmt={AMZ_VOUCHER}
                />
                {/* <HowToComponent
                    title={"How to Invest with InCred Unlisted"}
                    steps={active === "refer" ? HOW_TO_REFER_STEPS : HOW_TO_REFERRAL_STEPS}
                    buttons={[
                        {
                            label: "Refer a Friend",
                            variant: "",
                            onClick: HandleRefer,
                        },
                    ]}
                /> */}
                <HowToInvest
                    title="How does it work?"
                    steps={[
                        {
                            imageSrc: HowTo1,
                            title: "Refer your friend",
                            description: "Refer your friend by sending an email invite or by directly sharing your referral invitation link",
                        },
                        {
                            imageSrc: HowTo2,
                            title: "Sign up & buy shares",
                            description: "Your friend signs up using your referral invitation link and starts investing",
                        },
                        {
                            imageSrc: HowTo3,
                            title: "Get offer benefits",
                            description: "Refer your friends and get ₹750 cashback and 0.25% 1% of the amount invested by your friend in the offer period",
                        }
                    ]}
                />
                <Testimonial
                    redirectTo={
                        (isAuthenticated
                            ? `${getCleanDomain(process.env.ICM_POST_URL || "", true)}`
                            : `${process.env.ICM_URL}`) + "/refer"
                    }
                    btnName="Refer a Friend"
                    eventName="Refer_Homepage_Refer_Friend"
                    sectionClassNames="px-6"
                />
                <Faq
                    bgColor="bg-neutral-50"
                    compact={false}
                    product="unlistedEquities"
                    subProduct="referral"
                />
            </div>
            {!isAuthenticated ? <ScrollableButtonRefer isAuthenticated={isAuthenticated} /> : null}
        </Suspense>
    );
}
